<style lang="less"  >
@import "./about.less";
</style>
<template>
  <div class="index-about-out">
    <!-- 部分一 -->
    <div class="about-one-out">
      <div class="about-one">
        <h3 class="about-title">{{exhibitInfo.name}}</h3>
        <!-- banner -->
        <div class="about-banner-out">
          <div class="banner-part-one">
            <swiper :options="swiperOne" ref="mySwiper_a">
              <!-- slides -->
              <swiper-slide v-for="(slide, index) in bannerList" :key="index">
                <img :src="slide" class="banner_img" @click.stop="showModalEvent" >
              </swiper-slide>
              <!-- Optional controls -->
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div class="banner-part-one">
            <swiper :options="swiperOne" ref="mySwiper_b">
              <!-- slides -->
              <swiper-slide v-for="(slide, index) in bannerList" :key="index">
                <img :src="slide" class="banner_img" @click.stop="showModalEvent">
              </swiper-slide>
              <!-- Optional controls -->
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <!-- audio -->
        <div class="about-audio-out">
          <i class="iconfont iconplay" @click="iconPlayEvent" :hidden="audioIsPlay"/>
          <i class="iconfont iconzanting" @click="iconPauseEvent" :hidden="!audioIsPlay"/>
          <div class="about-audio-right">
            <div class="audio-line">
              <audio
                ref="zhpingAudio"
                @error="onAudioError"
                :src="audioUrl"
                autoplay="autoplay"
                @loadedmetadata="audioCanPlay"
                @timeupdate="audioTimeUpdate"
                @play="audioPlayEvent"
                @ended="audioEndEvent"
                @pause="audioPauseEvent"
              />
              <div class="audio-l-a" ref="audio_time"></div>
              <div class="audio-l-b" :style="{'width':`${audioWidth}px`}"></div>
            </div>
            <div class="audio-txt">
              <span>{{currAudioTimeStr}}</span>
              <span>{{audioDurationStr}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 部分二 -->
    <div class="about-two-out">
      <div class="about-two" ref="about_two">
        <div class="about-out-iii" :style="{'height':heightVal}">
          <div class="about-iii" ref="about_iii">{{exhibitInfo.description || '暂无介绍'}}</div>
        </div>
        <div class="ab-button" v-if="isHeight">
          <span @click="changeHeightEvent">{{heightVal === 'auto'?'收起':'全文'}}</span>
        </div>
      </div>
    </div>
    <!-- 部分三 -->
    <div class="about-three-out">
      <!-- 留言一 -->
      <div class="about-three-a" v-for="item in oneCommentList" :key="item.id">
        <div class="about-three-one">
          <h3>{{item.nickname}}</h3>
          <span class="commit-time">{{item.showTime}}</span>
          <p class="commit-icon">
            {{item.star}}
            <i class="iconfont icondianzan-ash"></i>
          </p>
        </div>
        <div class="about-three-two">{{item.content}}</div>
      </div>
    </div>
    <!-- 层 -->
    <div class="about-layer">
      <!-- ar -->
      <div
        class="bakc-in"
        @click="jumbAREvents"
        v-if="exhibitId == 915 || exhibitId == 9495 || exhibitId == 9497"
      >
        <p class="back-p">
          <i class="iconfont iconar-copy"></i>
        </p>
        <span class="back-t">AR</span>
      </div>
      <!-- 3d -->
      <div class="bakc-in" @click="jumb3dEvents" v-if="exhibitId == 915">
        <p class="back-p">
          <i class="iconfont icon3d"></i>
        </p>
        <span class="back-t">3D</span>
      </div>
      <!-- 返回 -->
      <div class="bakc-in" @click="backEvent">
        <p class="back-p">
          <i class="iconfont iconnext"></i>
        </p>
        <span class="back-t">返回</span>
      </div>
    </div>

    <!-- 大图展示 -->
    <div class="big-pic-close" v-if="currImgModal" @click="closeModalEvent"><i class="iconfont iconWrong"></i></div>
    <div class="big-pic-modal" v-if="currImgModal" >
         <img class="big-pic-img" v-if="currImgUrl" :src="currImgUrl" >
    </div>

  </div>
</template>
<script>
import { zhanpingInfoApi, commentListApi } from "@/api.js";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import {
  getParams,
  timeStampMake,
  secondMakeFun,
  localSave,
  localDelet
} from "@/libs/util.js";

export default {
  name: "about",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      // 展品Id
      exhibitId: null,
      // 展品信息
      exhibitInfo: {},
      // banner源
      bannerList: [],
      // swiper-部分一
      swiperOne: {
        pagination: {
          el: ".swiper-pagination"
        }
      },
      // 音频
      audioUrl: "",
      // 内容高度是否大于框架高度
      isHeight: false,
      // 框架高度（auto:全部显示）
      heightVal: "3.6rem",
      // 一级评论
      oneCommentList: [],
      oneCommentTotal: 0,
      // 音频时长
      audioDuration: 0,
      // 音频显示时长
      audioDurationStr: "00:00",
      // 音频正播放时间
      currAudioTime: 0,
      // 音频显示正播放时间
      currAudioTimeStr: "00:00",
      // 音频正在播放
      audioIsPlay: false,
      // 音频播放进度
      audioWidth: 0,
      // 当前图地址
      currImgUrl: '',
      // 当前图模态框
      currImgModal: false,
    };
  },
  methods: {
    // 内容高度切换
    changeHeightEvent() {
      const heightVal = this.heightVal;
      this.heightVal = heightVal === "auto" ? "3.6rem" : "auto";
    },
    // 返回事件
    backEvent() {
      this.$router.back();
    },
    // 评论加载
    getCommentFun() {
      let param = { index: 1, size: 20, type: 1, lv3Id: this.exhibitId };
      commentListApi(param)
        .then(suc => {
          if (suc && suc.code === 200) {
            let oneCommentList = (suc.data && suc.data.records) || [];
            let oneCommentTotal = (suc.data && suc.data.total) || [];
            oneCommentList.map(i => {
              i.showTime = i.createTime ? timeStampMake(i.createTime) : 0;
            });
            this.oneCommentList = oneCommentList;
            this.oneCommentTotal = oneCommentTotal;
          }
        })
        .finally(() => {});
    },
    // 音频失败
    onAudioError(e) {
      // this.$message.error("文件错误");
      console.log(e);
    },
    // 音频加载
    audioCanPlay() {
      let audioDuration = this.$refs.zhpingAudio.duration || 0;
      let audioDurationStr = secondMakeFun(audioDuration, 2);
      this.audioDuration = audioDuration;
      this.audioDurationStr = audioDurationStr;
    },
    // 音频正在播放时
    audioTimeUpdate(e) {
      if (!this.$refs.zhpingAudio) return;
      let currAudioTime = this.$refs.zhpingAudio.currentTime;
      let currAudioTimeStr = secondMakeFun(currAudioTime, 2);
      let audioDuration = this.audioDuration;
      this.currAudioTime = currAudioTime;
      this.currAudioTimeStr = currAudioTimeStr;
      let twidth = this.$refs.audio_time.getBoundingClientRect().width;
      let audioWidth = (audioDuration && currAudioTime / audioDuration) || 0;
      this.audioWidth = audioWidth * twidth;
    },
    // 开始播放
    iconPlayEvent() {
      this.$refs.zhpingAudio.play();
    },
    // 暂停播放
    iconPauseEvent() {
      this.$refs.zhpingAudio.pause();
    },
    // 音频播放
    audioPlayEvent() {
      this.audioIsPlay = true;
    },
    // 播放结束
    audioEndEvent() {
      this.audioIsPlay = false;
    },
    // 播放暂停
    audioPauseEvent() {
      this.audioIsPlay = false;
    },
    // 跳转3d
    jumb3dEvents() {
      window.location.href = "https://morview.com/h5/3d.html";
    },
    // 跳转AR
    jumbAREvents() {
      let exhibitId = this.exhibitId;
      if (!exhibitId) return;
      this.$router.push({ name: "videoShow", query: { id: exhibitId } });
    },
    // 关闭图片
    closeModalEvent() {
      this.currImgModal = false
      this.currImgUrl = ''
    },
    // 展示图片
    showModalEvent(e) {
      const currImgUrl = e.target.src || ''
      if(!currImgUrl) return
      this.currImgModal = true
      this.currImgUrl = currImgUrl
    }
  },
  computed: {
    swiper_a() {
      return this.$refs.mySwiper_a.swiper;
    },
    swiper_b() {
      return this.$refs.mySwiper_b.swiper;
    }
  },
  mounted() {},
  created() {
    const This = this;
    let urlObj = getParams(window.location.href);
    // swiperList用于大图展示
    localDelet("swiperList");
    this.exhibitId = urlObj.id;
    const l = this.$message.loading({
      message: "加载中",
      align: "center",
      showClose: false
    });
    zhanpingInfoApi(this.exhibitId, { osType: "android", appType: "xcx" })
      .then(suc => {
        if (suc && suc.code === 200) {
          let exhibitInfo = suc.data || {};
          let bannerList = exhibitInfo.images || [];
          let audioUrl =
            exhibitInfo.audio &&
            exhibitInfo.audio.mandarin &&
            exhibitInfo.audio.mandarin.url;
          bannerList = bannerList.map(i => i.url);
          This.bannerList = bannerList;
          localSave("swiperList", JSON.stringify(bannerList));
          This.audioUrl = audioUrl;
          This.exhibitInfo = exhibitInfo;
          This.$nextTick(() => {
            const b = This.$refs.about_iii.getBoundingClientRect().height || 0;
            const a = This.$store.state.app.htmlFontSize;
            This.isHeight = b > a * 3.6;
            // This.swiper_a.on("tap", function(e) {
            //   This.$router.push({ name: "swiperPic" });
            // });
            // This.swiper_b.on("tap", function(e) {
            //   This.$router.push({ name: "swiperPic" });
            // });
          });
          This.getCommentFun();
        }
      })
      .finally(() => {
        l.close();
      });
  }
};
</script>
